// extracted by mini-css-extract-plugin
module.exports = {"logo":"MainNavigation_logo__Je5Bf","nav":"MainNavigation_nav__eRzEO","navContainer":"MainNavigation_navContainer___YPYm"};